const USER_NUMBER = [
  '581437', // 测试-周凯
  '066115', // 王思雅
  '043904', // 刘欣深圳
  '030096', // 李春蕾
  '054098', // 汤焱梅
  '060091', // 杨九江
  '066506', // 颜丹丹
  '003671', // 章艳
  '003219', // 刘春秀
  '057135', // 王露市场
  '030177', // 胡亚露
  '003553', // 方祈渊
  '041712', // 凌玉
  '068395', // 郑磊
  '093263', // 陈晶
  '174065', // 周凯
  '626141', // 广发
  '609695', // 何阳04
  '459012', // 李元
  '100849' // 崔承杰
]

// 用来判断当前instance是否是路由组件的
export const isRouteComponent = vm => {
  if (!vm.$vnode) {
    return false
  }
  // routerViewDepth = 0 是每个业务线的layout组件, 为1的是具体路由组件
  return vm.$vnode.data.routerView && vm.$vnode.data.routerViewDepth === 1
}

// 获取某个模块的打开时间
export const getModuleOpenTime = (menuId) => {
  const recodes = window.__ERP_MENU_OPEN_TIME__
  return menuId ? recodes[menuId] : null
}


// 获取模块名称
export const getModuleName = (store, menuId) => {
  const menus = store.state.menus || {}
  const menuList = Object.values(menus)
  const menu = menuList.find(item => item.id === menuId)
  return menu ? menu.title : '未知模块'
}


// 限制上报范围
export const isReport = () => {
  const user = window.__ERPUSER__ || {}
  return USER_NUMBER.includes(user.employeeNumber)
}


// 空闲上报，不阻塞流程
export const reportOnIdle = fn => {
  if (window.scheduler && window.scheduler.postTask) {
    window.scheduler.postTask(fn, {
      priority: 'background'
    })
  } else {
    return setTimeout(fn, 3000)
  }
}




// WEBPACK FOOTER //
// ./src/public/mixins/module-mounted-report/utils.js